import ReactDOM from "react-dom";
import React from "react";
import App from "./components/Application";
import { AppContainer } from 'react-hot-loader';
import {store} from "./store";
import "./console";

import 'react-tippy/dist/tippy.css';
import "react-datepicker/dist/react-datepicker.css";
import './css/bootstrap.mod.css';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './css/_skin.scss';
import './css/nova-colored.scss';
import './css/nova-adminlte/theme.css';

import './css/admin.lte.scss';

window.envBooqadmin.title = window.envBooqadmin.title || document.title;

const render = App => {
    ReactDOM.render(<AppContainer><App store={store} /></AppContainer>, document.getElementById("app"));
}

render(App);

if (module.hot) {
    module.hot.accept("./components/Application.js", () => {
        const NextApp = require("./components/Application.js").default;

        render(NextApp);
    })
}